import { Toast, ToastMessage } from 'primereact/toast';
import React, { ReactNode, createContext, useContext, useRef } from 'react';

interface ToastContextProps {
    showToast: (options: ToastMessage | ToastMessage[]) => void;
}

const ToastContext = createContext<ToastContextProps | undefined>(undefined);

interface ToastProviderProps {
    children: ReactNode;
}

const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
    const toastRef = useRef<Toast>(null);

    const showToast = (options: ToastMessage | ToastMessage[]) => {
        if (toastRef.current) {
            toastRef.current.show(options);
        }
    };

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            <Toast ref={toastRef} baseZIndex={9999999} appendTo={document.body} position="top-right" />
        </ToastContext.Provider>
    );
};

const useToastContext = (): ToastContextProps => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};

export { ToastProvider, useToastContext };
